  <template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Création des <strong>tarifs</strong>  
          </div>
          <b-row class="form-group">
             <b-col md="6">
              <label for="grille_tarifaire">Grille tarifaire (*)</label>
              <b-form-input type="text" v-model="grille_tarifaire" placeholder="Grille tarifaire"  @input="tarification_add" class="form-control" :disabled="add_tarif == true" id="grille_tarifaire"></b-form-input>
            </b-col>
          </b-row>    
        </b-card>    
           
        <b-card id="card_libelle">
          <div slot="header">
            Création des <strong>tarifs</strong>  
          </div>
          <b-row class="form-group">
            
             <b-col md="4">
              <label for="montant_min">Montant Minimum (*)</label>
              <b-form-input type="number" min="1" v-model="tarification.montant_min" placeholder="Montant minimum de l'operation" id="montant_min"></b-form-input>
            </b-col>
            <b-col md="4">
              <label for="solde">Montant Maximum (*)</label>
              <b-form-input type="number" min="1" v-model="tarification.montant_max" placeholder="Montant maximum de l'operation" id="montant_max"></b-form-input>
            </b-col>
             <b-col md="4">
              <label for="tarif">Tarifs (*)</label>
              <b-form-input type="number" min="1" v-model="tarification.tarif" placeholder="Tarif de l'operation" id="tarif"></b-form-input>
            </b-col>
          </b-row>    
          <div slot="footer">
            <span v-if="tarificationAdd"><b-button type="submit" size="sm" variant="primary" @click.prevent="addTarification(tarification)"><i class="fa fa-dot-circle-o"></i> Ajouter</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Retour </b-button>
            <div style="float:right;" v-if="display_grille">
              <span v-if="can('tarification-create')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Enregistrer</b-button></span>
            </div>
          </div>
        </b-card>
         <b-card v-if="display_grille">
          <div slot="header">
            Liste des <strong>tarifications</strong> à ajouter 
          </div>
          <vue-good-table styleClass="vgt-table condensed" :columns="columns" :rows="tarifications" :fixed-header="false" :pagination-options="pagination" :search-options="search">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'btn'">
                    <!-- <router-link :to="'tarifications/show/' + props.row.id">
                      <b-dropdown id="ddown-sm-split" size="sm" split text="Plus de détails" class="m-2">
                        <div role="group" aria-lableledby="header1">                   
                            <router-link :to="'tarifications/edit/' + props.row.id" v-if="can('tarification-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                            <b-dropdown-item-button aria-describedby="header1" v-if="can('tarification-delete')"><i class="fa fa-trash"></i> Supprimer</b-dropdown-item-button>
                            <router-link :to="'tarifications/show/' + props.row.id" v-if="can('tarification-list')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link>
                        </div>
                        
                      </b-dropdown>
                    </router-link> -->
                    <b-button variant="success" style="width:70px;" title="Modifier la grille" class="btn-pill" @click="editGrille(props.row)">
                      <i class="fa fa-edit"></i>&nbsp;
                    </b-button>
                    <b-button variant="danger" style="width:70px;" title="Supprimer la grille" class="btn-pill" @click="removeGrille(props.row)">
                      <i class="fa fa-trash"></i>&nbsp;
                    </b-button>
                    
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
          </vue-good-table>
          <div slot="footer">
            <b-button type="reset" style="width:150px;" @click="cancel" size="sm" variant="danger"><i class="fa fa-ban"></i> Vider le tableau </b-button>
           </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      tarif_modif:'',
      display_grille :true,
      tarificationAdd:true,
      editState:false,
      tarification:{
        montant_min: 0,
        montant_max: 0,
        tarif: 0
      },
      grille_tarifaire:'',
      tarifications:[],
      grille:{
        grilletarifaire_libelle:'',
        tarifications:[]
      },
      columns: [
        {
          label: 'Tarif',
          field: 'tarif',
          type: 'number',
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant minimal',
          field: 'montant_min',
          type: 'number',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant maximal',
          field: 'montant_max',
          type: 'number',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          //perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search:{
            enabled: true,
            trigger: 'keyup',
            placeholder: 'Rechercher dans la table',
        },
        libelle_grille:'',
        add_tarif:false,
        serverParams: {
          page:1,
          current_page: 1,
          paginate: 10,
          libelle_grille:''
        },
    }
  },
  methods:{
      goBack() {
        this.$router.go(-1)
      },
      cancel() {
        this.tarifications=[]
      },
      countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      tarification_add(){
          if (this.grille_tarifaire.length>0){
          this.tarificationAdd = true
        }else{
          this.tarificationAdd = false
        }
      },
      displayGrille(){
        if (this.tarifications.length>0){
          this.display_grille = true
        }else{
          this.display_grille = false
        }
      },
      showAlert () {
        this.dismissCountDown = this.dismissSecs
      },
      removeGrille(tarification){
          let index = this.tarifications.findIndex(element=>{
            return element.tarif==tarification.tarif
          })
          console.log(index)
          this.tarifications.splice(index, 1)
      },
      editGrille(tarification){
        this.editState=true
        this.tarification.tarif= tarification.tarif
        this.tarif_modif= this.tarification.tarif
        this.tarification.montant_min= tarification.montant_min
        this.tarification.montant_max= tarification.montant_max
      },
      async post(){   
          this.grille.grilletarifaire_libelle = this.grille_tarifaire
          this.grille.tarifications = this.tarifications
          let grille = {grille:[this.grille]}
          this.response = await this.$store.dispatch('tarification/post_tarifications',grille)
          this.showAlert()
          if(this.response.success == true){
            this.display_grille = false
            this.reset()
          }
      },
      async addTarification(tarification){
        console.log(tarification)
        if((tarification.tarif>=0) && (tarification.montant_min>=0) && (this.tarification.montant_max>=0)){
          if(parseInt(tarification.montant_min)<parseInt(tarification.montant_max)){
            if(this.editState==false){
              
              this.tarification.tarif = tarification.tarif.toLocaleString()
              this.tarification.montant_min = tarification.montant_min.toLocaleString()
              this.tarification.montant_max = tarification.montant_max.toLocaleString()
              this.tarifications.push(this.tarification) 
              
            }else{
              let index = this.tarifications.findIndex(element=>{
                return element.tarif==this.tarif_modif
              })
              console.log("index ",index)
              tarification.tarif = tarification.tarif.toLocaleString()
              tarification.montant_min = tarification.montant_min.toLocaleString()
              tarification.montant_max = tarification.montant_max.toLocaleString()
              this.tarifications.splice(index, 1,tarification)
            }
            this.tarification={}
            this.displayGrille()
            this.editState=false
          }else{
            alert('Le montant maximale doit être supérieur au montant minimale')
          }
        }else{alert('Veuillez saisir des montants supérieurs à zéro.')}
      },
      async get_all_tarifications(){
        this.$store.dispatch('tarification/get_all_tarifications').then(()=>{
          return this.rows =  store.getters['tarification/rows'];
        })
      },
      get_all_grilletarifaires() {
        if(this.$route.params.grilletarifaire_libelle != 'null' && this.$route.params.grilletarifaire_libelle != null){
          this.grille_tarifaire = this.$route.params.grilletarifaire_libelle
          this.add_tarif=true
          console.log('ma grille ',this.$route.params.grilletarifaire_libelle)
          this.serverParams.libelle_grille= this.$route.params.grilletarifaire_libelle
          this.$store.dispatch('tarification/get_all_tarifications_by_grille',this.serverParams).then((response)=>{
            this.totalRecords = response.total;
            return this.rows = store.getters['tarification/rows'];
          })
        }else{console.log("nothing to execute")}
      },
      // async get_all_grilletarifaires(){
      //       await this.$store.dispatch('grilletarifaire/get_all_grilletarifaires').then(()=>{
      //         return this.grille =  store.getters['grilletarifaire/rows'];
      //       })
      //       if(this.$route.params.grilletarifaire_libelle === null || this.$route.params.grilletarifaire_libelle === 'null'){
      //           this.display_grille = true
      //           this.grille.forEach((element)=>{
      //               this.options.push({
      //                 value:element.libelle,
      //                 text:element.libelle.toUpperCase()
      //               })
      //           })
      //       }else{
      //           console.log(this.$route.params.grilletarifaire_libelle)
      //           this.display_grille = false
      //           this.tarification.grilletarifaire_libelle = this.$route.params.grilletarifaire_libelle
      //           this.options.push({
      //               value:this.$route.params.grilletarifaire_libelle,
      //               text:this.$route.params.grilletarifaire_libelle.toUpperCase()
      //         })
      //       }
      // },
      // get_all_tarifications(){
      //     return this.rows = store.getters['tarification/rows'];
      // },
      can(perm){
            return store.getters['auth/can'](perm)
      },
      reset() {
        this.tarification.tarif= '',
        this.tarification.montant_min= '',
        this.tarification.montant_max= ''
      }
  },
  mounted(){
    this.get_all_grilletarifaires()
    this.displayGrille()
    this.tarification_add()
  }
}
</script>
